import { useState } from 'react'

import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    sortBy: (field: string) => {
      switch (field) {
        case 'name':
          return translate({ id: 'depots.list.sorter.sortBy.name' })
        case 'setupCost':
          return translate({ id: 'depots.list.sorter.sortBy.cost' })
        case 'setupTimeSec':
          return translate({ id: 'depots.list.sorter.sortBy.setupTime' })
        default:
          console.warn(`Unknown depot field: ${field}`)
          return ''
      }
    },

    sortByField: (field: string) =>
      translate({ id: 'depots.list.sorter.sortBy', values: { field } }),

    sortByName: translate({ id: 'depots.list.sorter.sortBy.name' }),
    sortByCost: translate({ id: 'depots.list.sorter.sortBy.cost' }),
    sortBySetupTime: translate({ id: 'depots.list.sorter.sortBy.setupTime' }),
    sortAscending: translate({ id: 'depots.list.sorter.sortBy.direction.ascending' }),
    sortDescending: translate({ id: 'depots.list.sorter.sortBy.direction.descending' }),
  }))

  return api
}
